import Icon from "../../../components/ui/Icon";
import NotificationCard from "./NotificationCard";

export default function NotificationsPage({ notifications, gatewayConnected, nodesScanned, onNavigate, onConnectToGateway, onScanNetwork }) {
  if (!gatewayConnected) {
    return (
      <div className="flex flex-col items-center justify-center gap-5 rounded-3xl border border-brand-navy bg-brand-navy px-4 py-14 text-center">
        <span className="flex h-14 w-14 items-center justify-center rounded-full bg-brand-purple">
          <Icon name="bluetooth_disabled" className="text-3xl text-brand-light/40" />
        </span>
        <div className="space-y-1.5">
          <p className="text-base font-semibold text-brand-light">No gateway connected</p>
          <p className="text-sm text-brand-light/50 max-w-[260px] mx-auto">
            Connect to a cBerry Bluetooth-CAN gateway to receive system alerts and network notifications.
          </p>
        </div>
        <button
          type="button"
          onClick={onConnectToGateway}
          className="w-full max-w-xs rounded-xl bg-brand-magenta px-4 py-3 text-sm font-semibold text-white shadow hover:bg-brand-pink transition"
        >
          Connect to Gateway
        </button>
      </div>
    );
  }

  if (!nodesScanned) {
    return (
      <div className="flex flex-col items-center justify-center gap-5 rounded-3xl border border-brand-navy bg-brand-navy px-4 py-14 text-center">
        <span className="flex h-14 w-14 items-center justify-center rounded-full bg-brand-purple">
          <Icon name="hub" className="text-3xl text-brand-light/40" />
        </span>
        <div className="space-y-1.5">
          <p className="text-base font-semibold text-brand-light">Network not scanned</p>
          <p className="text-sm text-brand-light/50 max-w-[260px] mx-auto">
            Scan the CAN bus to discover nodes and receive device notifications.
          </p>
        </div>
        <button
          type="button"
          onClick={onScanNetwork}
          className="w-full max-w-xs rounded-xl bg-brand-magenta px-4 py-3 text-sm font-semibold text-white shadow hover:bg-brand-pink transition"
        >
          Scan Network
        </button>
      </div>
    );
  }

  if (notifications.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center gap-5 rounded-3xl border border-emerald-500/30 bg-emerald-500/5 px-4 py-14 text-center">
        <span className="flex h-14 w-14 items-center justify-center rounded-full bg-emerald-500/20 border border-emerald-500/30">
          <Icon name="check_circle" className="text-3xl text-emerald-400" />
        </span>
        <div className="space-y-1">
          <p className="text-base font-semibold text-brand-light">All systems OK</p>
          <p className="text-sm text-brand-light/50">No active alerts on this network.</p>
        </div>
      </div>
    );
  }

  const criticalCount = notifications.filter((n) => n.severity === "critical").length;
  const warningCount = notifications.filter((n) => n.severity === "warning").length;
  const infoCount = notifications.filter((n) => n.severity === "info").length;

  return (
    <div className="space-y-3">
      <div className="rounded-2xl border border-brand-navy bg-brand-purple px-4 py-3 flex items-center gap-3">
        <span className="flex h-10 w-10 items-center justify-center rounded-full bg-brand-navy border border-brand-navy shrink-0">
          <Icon name="notifications_active" className="text-xl text-brand-magenta" />
        </span>
        <div className="flex-1">
          <p className="text-sm font-semibold text-brand-light">
            {notifications.length} active notification{notifications.length !== 1 ? "s" : ""}
          </p>
          <div className="flex items-center gap-3 mt-0.5">
            {criticalCount > 0 && (
              <span className="text-[11px] font-semibold text-red-400">{criticalCount} critical</span>
            )}
            {warningCount > 0 && (
              <span className="text-[11px] font-semibold text-amber-400">
                {warningCount} warning{warningCount !== 1 ? "s" : ""}
              </span>
            )}
            {infoCount > 0 && (
              <span className="text-[11px] font-semibold text-brand-magenta">{infoCount} info</span>
            )}
          </div>
        </div>
      </div>
      {notifications.map((item) => (
        <NotificationCard key={item.id} item={item} onAction={onNavigate} />
      ))}
    </div>
  );
}
